import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { openBuyVideoOverlay } from 'widget/redux/client/actions/mobile-overlay-openners/payment-pages-actions';
import ThreeRowsWidgetOverlay from 'widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget';
import { getChannelForWidget } from 'shared/selectors/channels';
import { PlayerCover } from 'widget/components/player-cover/player-cover';
import {
  getFullAccessActionName,
  FULL_ACCESS_ACTION_NAMES,
} from 'widget/ui-selectors/video-access';

import { openVideoPage } from 'widget/redux/client/actions/mobile-overlay-openners/main-openners';

import styles from './players-list-slidable.styl';


@connect(state => {
  const channelData = getChannelForWidget(state);

  return {
    channelData,
    appSettings: state.appSettings,
    currentSiteUser: state.currentSiteUser,
  };
}, (dispatch, { videoItem }) => ({
  onBuyVideoClick: () => dispatch(openBuyVideoOverlay(videoItem.id)),
  onOpenVideoClick: () => dispatch(openVideoPage(videoItem.id)),
}))
export default class Player extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    canShowChannelCover: React.PropTypes.bool,
    onBuyVideoClick: React.PropTypes.func,
    onOpenVideoClick: React.PropTypes.func,

    videoItem: React.PropTypes.object,
    useChannelCoverIfPossible: React.PropTypes.bool,
    className: React.PropTypes.string,
    coverClassName: React.PropTypes.string,
    onPause: React.PropTypes.func,
    paused: React.PropTypes.bool,
    itemWidth: React.PropTypes.number,
    itemHeight: React.PropTypes.number,
    currentSiteUser: React.PropTypes.object,
    onPlayClick: React.PropTypes.func,
    onPlayStart: React.PropTypes.func,
    onFullScreenChanged: React.PropTypes.func,
    onMemberSignUp: React.PropTypes.func,
  };

  @autobind
  onPlayClick() {
    const {
      onPlayClick,
      channelData,
      videoItem,
      currentSiteUser,
      onMemberSignUp,
    } = this.props;

    const accessActionName = getFullAccessActionName(channelData, videoItem, currentSiteUser);

    if (accessActionName === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
      onMemberSignUp();
    } else {
      onPlayClick();
    }
  }

  render() {
    const {
      videoItem, useChannelCoverIfPossible, className, itemWidth, itemHeight, paused,
      onOpenVideoClick, onBuyVideoClick, channelData, appSettings,
      } = this.props;

    const coverClassNames = classnames(className, { paused });

    return (
      <PlayerCover videoItem={videoItem}
                   className={coverClassNames}
                   useChannelCoverIfPossible={useChannelCoverIfPossible}
                   coverWidth={itemWidth}
                   coverHeight={itemHeight}>
        <ThreeRowsWidgetOverlay videoItem={videoItem}
                                className={styles['slidable-overlay']}
                                appSettings={appSettings}
                                channelData={channelData}
                                showChannelCover={useChannelCoverIfPossible}
                                onOpenVideoClick={onOpenVideoClick}
                                onBuyVideoClick={onBuyVideoClick}
                                onPlayClick={this.onPlayClick} />
      </PlayerCover>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/players-list-slidable/fake-player.js